import React, { useState } from "react";
import { Modal, Tab } from "react-bootstrap";
import dayjs from "dayjs";

//internal import
import PageHeader from "../../components/common/PageHeader";
import useProjectSubmit from "../../hooks/useProjectSubmit";
import InputArea from "../../components/Input/InputArea";
import Error from "../../components/Input/Error";
import ProjectListTable from "../../components/Projects/ProjectListTable";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import ProjectService from "../../services/ProjectService";
import DropDownService from "../../services/DropDownService";
import { useLocation } from 'react-router-dom';

function Projects() {

    const [projectId, setProjectId] = useState("");
    const { data, loading } = useAsync(() => ProjectService?.getAllProject());
    const { data: employeeData, loading: employeeLoading } = useAsync(() => DropDownService.employeeDropDown());
    const location = useLocation();
    const { pathname } = location; 
    const { data:permissionData } = useAsync(() => DropDownService.getModulePermissions({ path:pathname, userId:localStorage.id})); 
    var addPermission = typeof permissionData?.data?.add === 'undefined' ? 1: permissionData?.data?.add; 
    var viewPermission = typeof permissionData?.data?.view === 'undefined' ? 1: permissionData?.data?.view;
    var editPermission = typeof permissionData?.data?.edit === 'undefined' ? 1: permissionData?.data?.edit; 
    var deletePermission = typeof permissionData?.data?.delete === 'undefined' ? 1: permissionData?.data?.delete; 
    var listPermission = typeof permissionData?.data?.list === 'undefined' ? 1: permissionData?.data?.list;

    const {
        register,
        handleSubmit,
        errors,
        onSubmit,
        handleDeleteProject,
        isModal,
        setIsModal,
        isViewModal,
        setIsViewModal,
        isDeleteModal,
        setIsDeleteModal,
        viewData } = useProjectSubmit(projectId);

    return (
        <div className="container-xxl">
            {loading || employeeLoading ? <ModalLoading loading={loading} /> :
                <>
                    <Tab.Container defaultActiveKey="All">
                        <PageHeader addPermission={addPermission} headerTitle="Projects"
                            renderRight={() => {
                                return <div className="d-flex py-2 project-tab flex-wrap w-sm-100">
                                    <button type="button" className="btn btn-dark w-sm-100" onClick={() => { setIsModal(true); setProjectId(""); }}><i className="icofont-plus-circle me-2 fs-6"></i>Create Project</button>
                                </div>
                            }} />

                    </Tab.Container> 
                    <ProjectListTable deletePermission={deletePermission} editPermission={editPermission} viewPermission={viewPermission} listPermission={listPermission} setIsModal={setIsModal} setProjectId={setProjectId} setIsDeleteModal={setIsDeleteModal} setIsViewModal={setIsViewModal} data={data} />
                </>

            }

            {/* project view modal */}
            <Modal show={isViewModal} size="lg" centered onHide={() => { setIsViewModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Project Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="modal-body">
                        <div className="deadline-form">
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Project Name </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.projectName}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Category </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.projectCategory}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Assign Person </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.assignPerson?.employeeName}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Start Date </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{dayjs(viewData?.projectStartDate).format("DD-MM-YYYY")}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> End Date </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{dayjs(viewData?.projectEndDate).format("DD-MM-YYYY")}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> priority </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.priority}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Description </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.description || "-"}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Status </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.projectStatus}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Project Status </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.status}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* project add and edit modal */}
            <Modal show={isModal} onHide={() => { setIsModal(false); }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">{projectId ? "Update " : "Add"} Project</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput77" className="form-label">Project Name</label>
                            <InputArea register={register} required={"true"} label={"Name"} name="projectName" type="text" className="form-control" id="exampleFormControlInput77" placeholder="Explain what the Project Name" />
                            <Error errorName={errors?.projectName} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Project Category</label>
                            <select className="form-select"{...register(`projectCategory`, { required: `Category is required!` })}>
                                <option value="" defaultValue>Select Category</option>
                                <option value="UI/UX Design">UI/UX Design</option>
                                <option value="Website Design">Website Design</option>
                                <option value="App Development">App Development</option>
                                <option value="Quality Assurance">Quality Assurance</option>
                                <option value="Development">Development</option>
                                <option value="Backend Development">Backend Development</option>
                                <option value="Software Testing">Software Testing</option>
                                <option value="Website Design">Website Design</option>
                                <option value="Marketing">Marketing</option>
                                <option value="SEO">SEO</option>
                                <option value="Other">Other</option>
                            </select>
                            <Error errorName={errors?.projectCategory} />
                        </div>
                        {/* <div className="mb-3">
                        <label htmlFor="formFileMultipleone" className="form-label">Project Images &amp; Document</label>
                        <input className="form-control" type="file" id="formFileMultipleone" multiple="" />
                    </div> */}
                        <div className="deadline-form">
                            <div className="row g-3 mb-3">
                                <div className="col">
                                    <label htmlFor="datepickerded" className="form-label">Project Start Date</label>
                                    <InputArea register={register} name="projectStartDate" label={"Start Date"} type="date" className="form-control" id="datepickerded" />
                                    <Error errorName={errors?.projectStartDate} />
                                </div>
                                <div className="col">
                                    <label htmlFor="datepickerdedone" className="form-label">Project End Date</label>
                                    <InputArea register={register} name="projectEndDate" label={"End Date"} type="date" className="form-control" id="datepickerdedone" />
                                    <Error errorName={errors?.projectEndDate} />
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-12">
                                    <label htmlFor="formFileMultipleone" className="form-label">Task Assign Person</label>
                                    <select className="form-select" {...register(`assignPerson`, { required: `Person is required!` })}>
                                        <option value="" defaultValue >Select Person</option>
                                        {employeeData?.data?.map((employee, index) => (
                                            <option key={index} value={employee?.value}>{employee?.label}</option>
                                        ))}
                                    </select>
                                    <Error errorName={errors?.assignPerson} />
                                </div>
                            </div>
                        </div>
                        <div className="row g-3 mb-3">
                            <div className="col-sm">
                                <label htmlFor="formFileMultipleone" className="form-label">Priority</label>
                                <select
                                    className="form-select" {...register(`priority`, { required: `Priority is required!` })}>
                                    <option value="" defaultValue >Select Priority</option>
                                    <option value="Highest" >Highest</option>
                                    <option value="Medium">Medium</option>
                                    <option value="Low">Low</option>
                                    <option value="Lowest">Lowest</option>
                                </select>
                                <Error errorName={errors?.priority} />
                            </div>
                        </div>
                        <div className="row g-3 mb-3">
                            <div className="col-sm">
                                <label className="form-label">Project Status</label>
                                <select
                                    className="form-select" {...register(`projectStatus`, { required: `Project Status is required!` })}>
                                    <option value="" >Select Status</option>
                                    <option value="Open">Open</option>
                                    <option value="In Progress">In Progress</option>
                                    <option value="Completed">Completed</option>
                                </select>
                                <Error errorName={errors?.projectStatus} />
                            </div>
                        </div>
                        <div className="row g-3 mb-3">
                            <div className="col-sm">
                                <label className="form-label"> Status</label>
                                <select
                                    className="form-select" {...register(`status`, { required: `Status is required!` })}>
                                    <option value="" >Select Status</option>
                                    <option value="Active">Active</option>
                                    <option value="In Active">In Active</option>
                                </select>
                                <Error errorName={errors?.status} />
                            </div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlTextarea78" className="form-label">Description (optional)</label>
                            <textarea {...register(`description`, { required: false })} name="description" className="form-control" id="exampleFormControlTextarea78" rows="3" placeholder="Add any extra details about the request"></textarea>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => { setIsModal(false) }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">{projectId ? "Update " : "Add"}</button>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* project delete modal */}
            <Modal show={isDeleteModal} centered onHide={() => { setIsDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Delete Project</Modal.Title>
                </Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <i className="icofont-ui-delete text-danger display-2 text-center mt-2"></i>
                    <p className="mt-4 fs-5 text-center">Are You Sure! Want to Delete Project ?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsDeleteModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-danger color-fff" onClick={() => handleDeleteProject(projectId)}>Delete</button>
                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default Projects;